module.exports = __webpack_public_path__ + "img/my-program-icon.bd7d525a.svg";